import { apiConstatnts } from "constants/apiConstants";
import httpRequset from "utils/HttpRequest";

const { REACT_APP_API_URL } = process.env;

async function signInWithPhone(uid: string, phone: number) {
  try {
    const url = `${REACT_APP_API_URL}/auth/user/phone/signIn`;

    const body = JSON.stringify({
      uid: uid,
      phone: phone,
    });

    return httpRequset(apiConstatnts.POST, apiConstatnts.DISABLE_AUTHORIZATION, apiConstatnts.contentType.JSON, url, body);
  } catch (error) {
    // console.log("error : ", error);
    throw error;
  }
}

async function signInWithGoogle(uid: string, email: string) {
  try {
    const url = `${REACT_APP_API_URL}/auth/user/google/signIn`;

    const body = JSON.stringify({
      uid: uid,
      email: email,
    });

    return httpRequset(apiConstatnts.POST, apiConstatnts.DISABLE_AUTHORIZATION, apiConstatnts.contentType.JSON, url, body);
  } catch (error) {
    // console.log("error : ", error);
    throw error;
  }
}

export const authService = {
  signInWithPhone,
  signInWithGoogle,
};
